/**
 * ProfessionalBottomNavigation Component
 * Navigation bar for salon staff with professional-focused features
 * Features: Dashboard only for initial implementation (expandable)
 */

import { 
  LayoutDashboard,
  Calendar,
  Users,
  Menu,
  Kanban
} from 'lucide-react';
import { useNavigation } from '../shared/hooks/useNavigation';
import { BOTTOM_NAV_CONFIG } from '../shared/navigation';

const ProfessionalBottomNavigation = () => {
  const { navigate, isActive } = useNavigation();

  // Icon mapping
  const iconMap = {
    'dashboard': LayoutDashboard,
    'agenda': Calendar,
    'clients': Users,
    'kanban': Kanban,
    'menu': Menu,
  };

  // Navigation items from config with icons and state
  const navigationItems = BOTTOM_NAV_CONFIG.PROFESSIONAL.map(item => ({
    ...item,
    icon: iconMap[item.key] || Menu,
    isActive: isActive(item.route),
    path: item.route
  }));

  return (
    <div className="bg-brand-light dark:bg-brand-dark border-t border-brand-dark/10 dark:border-brand-light/10 px-2 py-1 safe-area-bottom">
      <div className="flex justify-around items-center">
        {navigationItems.map((item) => {
          const IconComponent = item.icon;

          return (
            <button
              key={item.key}
              onClick={() => navigate(item.route)}
              className={`flex flex-col items-center py-1 px-1 transition-all duration-300 min-w-0 ${
                item.isActive
                  ? 'text-brand-dark dark:text-brand-light bg-brand-dark/5 dark:bg-brand-light/5'
                  : 'text-brand-dark/60 dark:text-brand-light/60 hover:text-brand-dark dark:hover:text-brand-light'
              }`}
            >
              <IconComponent
                size={20}
                strokeWidth={1.5}
                className={`mb-0.5 ${
                  item.isActive ? 'text-brand-dark dark:text-brand-light' : 'text-brand-dark/60 dark:text-brand-light/60'
                }`}
              />
              <span
                className={`text-[10px] font-medium leading-tight truncate max-w-[60px] uppercase tracking-wider ${
                  item.isActive ? 'text-brand-dark dark:text-brand-light' : 'text-brand-dark/60 dark:text-brand-light/60'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProfessionalBottomNavigation;